export const ENV = {
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV,
  prod: import.meta.env.PROD,
  baseUrl: import.meta.env.BASE_URL,

  // Public Vite env vars (only VITE_* are exposed to the client).
  apiPrefix: import.meta.env.VITE_API_PREFIX || '/api',

  // Build metadata (provided via vite.config.cjs -> define)
  appVersion: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0',
  buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '',
};

